import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, X } from "lucide-react";
import { reachGoal } from "@/lib/metrika";

function getEndOfWeek() {
  const now = new Date();
  const day = now.getDay() || 7; // Sunday = 7
  const diff = 7 - day;
  const end = new Date(now);
  end.setDate(now.getDate() + diff);
  end.setHours(23, 59, 59, 999);
  return end;
}

function format(ms: number) {
  if (ms < 0) ms = 0;
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms % 86400000) / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  return `${d}д ${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

const STORAGE_KEY = "urgent_offer_dismissed_v1";

export function UrgentOfferBar() {
  const [visible, setVisible] = useState(false);
  const [end] = useState(getEndOfWeek());
  const [left, setLeft] = useState(end.getTime() - Date.now());

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    const onScroll = () => {
      if (window.scrollY > window.innerHeight * 0.5) setVisible(true);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!visible) return;
    const i = setInterval(() => setLeft(end.getTime() - Date.now()), 1000);
    return () => clearInterval(i);
  }, [visible, end]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-3 left-1/2 z-40 w-[calc(100%-1.5rem)] max-w-2xl -translate-x-1/2 px-2 sm:bottom-5">
      <div className="glass-card flex flex-wrap items-center gap-3 border-warning/40 p-3 sm:flex-nowrap sm:p-4" style={{ boxShadow: "0 20px 40px -10px hsl(38 92% 50% / 0.3)" }}>
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-warning/15">
          <Flame className="h-5 w-5 text-warning" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-bold text-foreground sm:text-sm">
            −30% на годовой Pro + бесплатный аудит кампаний
          </p>
          <p className="font-mono text-[11px] text-muted-foreground sm:text-xs">
            До конца недели: <span className="font-bold text-warning">{format(left)}</span>
          </p>
        </div>
        <Link
          to="/pricing"
          onClick={() => reachGoal("urgent_offer_click")}
          className="inline-flex min-h-[40px] shrink-0 items-center gap-1 rounded-xl bg-gradient-to-r from-warning to-destructive px-4 py-2 text-xs font-bold text-white shadow-lg sm:text-sm"
        >
          Забрать скидку
        </Link>
        <button
          type="button"
          aria-label="Закрыть"
          onClick={() => { sessionStorage.setItem(STORAGE_KEY, "1"); setVisible(false); }}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-muted-foreground hover:bg-accent hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
